// SSR safe click away directive, based on https://github.com/VinceG/vue-click-away
// when coverting to composition api, consider using https://vueuse.org/core/onClickOutside/

/* eslint-disable no-param-reassign */
/* eslint-disable no-underscore-dangle */
/* eslint-disable import/prefer-default-export */
export const clickAwayDirective = {
    // Provide getSSRProps to prevent SSR errors
    getSSRProps() {
        // Return empty object - this directive doesn't need SSR props
        return {};
    },
    mounted(el, binding) {
        // Only runs on client
        if (typeof window === 'undefined') return;

        // eslint-disable-next-line func-names
        el._clickAwayHandler = function (event) {
            if (!(el === event.target || el.contains(event.target))) {
                binding.value(event);
            }
        };

        document.addEventListener('click', el._clickAwayHandler);
        document.addEventListener('touchstart', el._clickAwayHandler);
    },

    unmounted(el) {
        if (typeof window === 'undefined') return;

        if (el._clickAwayHandler) {
            document.removeEventListener('click', el._clickAwayHandler);
            document.removeEventListener('touchstart', el._clickAwayHandler);
            delete el._clickAwayHandler;
        }
    },
    beforeMount() {
        // Can be empty, just needs to exist for SSR
    },
};
